import { makeVar } from "shared/providers/apollo/apollo.package";

interface IClosedPeriodOverrideVar {
  // The server's PERIOD_CLOSED message ("Books are closed through ...")
  message: string;
  // Reason entered by the user, or null when they cancel
  resolve: (reason: string | null) => void;
}

/**
 * Open the "Post anyway" modal for a change the server refused because it
 * falls in a closed period
 */

export const closedPeriodOverrideVar = makeVar<IClosedPeriodOverrideVar | null>(
  null
);

// Kept so repeated overrides (inline edits on one bill) don't retype it
let lastReason = "";

export const getLastClosedPeriodReason = () => lastReason;

// One modal at a time - requests made while one is open wait their turn
let queue: Promise<unknown> = Promise.resolve();

export const requestClosedPeriodReason = (message: string) => {
  const request = queue.then(
    () =>
      new Promise<string | null>((resolve) =>
        closedPeriodOverrideVar({
          message,
          resolve: (reason) => {
            closedPeriodOverrideVar(null);

            if (reason) {
              lastReason = reason;
            }

            resolve(reason);
          },
        })
      )
  );

  queue = request;

  return request;
};
